import Label from "components/Label";
import React, { ElementType, FC } from "react";

import styles from "./styles.module.scss";

type Props = {
  columns: { name: string; Icon: ElementType }[][];
};

const Table: FC<Props> = ({ columns }) => {
  return (
    <div className={styles.table}>
      {columns.map((vendors) => (
        <div
          key={vendors.map(({ name }) => name).join("-")}
          className={styles.column}
        >
          {vendors.map(({ name, Icon }) => (
            <div key={name} className={styles.item}>
              <Icon className={styles.icon} />
              <Label
                className={styles.itemLabel}
                color="secondary"
                variant="centered-body"
              >
                {name}
              </Label>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Table;
